module.exports = __webpack_public_path__ + "694c9495ccab144100352b43db0012e3.png";